// What the ItemsList on screen holds that no request carries: edits that were never sent.
// The app bar reads it so a language or theme switch can warn the way leaving the page does.
const SET_UNSAVED_EDITS = 'EDITING_SET_UNSAVED_EDITS'

const initialState = {
  unsavedEdits: false,
}

export default (state = initialState, action) => {
  switch(action.type) {
    case SET_UNSAVED_EDITS: {
      return { ...state, unsavedEdits: action.unsavedEdits === true }
    }
    default:
      return state
  }
}

export const setUnsavedEdits = (unsavedEdits) => ({
  type: SET_UNSAVED_EDITS,
  unsavedEdits: unsavedEdits,
})
